import { timeOf, useConnectionBanner } from '@shkola/api';
import { useTranslation } from 'react-i18next';

/** «Немає звʼязку · дані станом на 10:42 · очікують відправлення: 2» — and «back» afterwards. */
export function OfflineBanner() {
  const { t } = useTranslation();
  const banner = useConnectionBanner();
  if (!banner) return null;
  if (banner.kind === 'back') {
    return (
      <div role="status" className="bg-emerald-600 px-4 py-2 text-center text-sm text-white">
        ✓ {t('offline.back')}
      </div>
    );
  }
  return (
    <div role="status" className="bg-slate-800 px-4 py-2 text-center text-sm text-white">
      <span className="font-semibold">{t('offline.banner')}</span>
      {banner.lastSync && (
        <span className="opacity-80">
          {' · '}
          {t('offline.since', { time: timeOf(new Date(banner.lastSync).toISOString()) })}
        </span>
      )}
      {banner.queued > 0 && (
        <span className="opacity-80">
          {' · '}
          {t('offline.queued', { count: banner.queued })}
        </span>
      )}
    </div>
  );
}
